import React from "react";

// Clean instructional SVG diagrams (obsidian bg, cyber-yellow accents).
const Y = "#CCFF00";
const W = "#FFFFFF";
const R = "#FF3B30";
const M = "#A3A3A3";

const Frame = ({ children, label }) => (
  <div className="w-full border border-[#262626] bg-[#0d0d0d]" data-testid="drill-diagram">
    <svg viewBox="0 0 320 180" className="w-full h-auto" role="img" aria-label={label || "drill diagram"}>
      <rect x="0" y="0" width="320" height="180" fill="#0d0d0d" />
      {children}
    </svg>
  </div>
);

function PuttingGate() {
  return (
    <Frame label="putting gate drill">
      <text x="12" y="20" fill={M} fontSize="9" fontFamily="monospace">BALL</text>
      <circle cx="160" cy="30" r="6" fill={W} />
      <text x="8" y="90" fill={M} fontSize="9" fontFamily="monospace">GATE</text>
      <line x1="140" y1="60" x2="140" y2="80" stroke={Y} strokeWidth="3" />
      <line x1="180" y1="60" x2="180" y2="80" stroke={Y} strokeWidth="3" />
      <line x1="160" y1="36" x2="160" y2="150" stroke={M} strokeWidth="1" strokeDasharray="4 4" />
      <circle cx="160" cy="160" r="9" fill="none" stroke={R} strokeWidth="2" />
      <text x="185" y="164" fill={M} fontSize="9" fontFamily="monospace">HOLE</text>
      <text x="128" y="55" fill={Y} fontSize="8" fontFamily="monospace">TEE</text>
      <text x="182" y="55" fill={Y} fontSize="8" fontFamily="monospace">TEE</text>
    </Frame>
  );
}

function LagLadder() {
  const rows = [
    { y: 40, d: "10FT" }, { y: 70, d: "20FT" }, { y: 100, d: "30FT" }, { y: 130, d: "40FT" },
  ];
  return (
    <Frame label="lag ladder drill">
      <circle cx="30" cy="160" r="7" fill={W} />
      <text x="12" y="150" fill={M} fontSize="8" fontFamily="monospace">START</text>
      {rows.map((r, i) => (
        <g key={i}>
          <line x1="60" y1={r.y} x2="280" y2={r.y} stroke={i === 0 ? Y : "#333"} strokeWidth="1" strokeDasharray="3 3" />
          <circle cx="230" cy={r.y} r="6" fill="none" stroke={R} strokeWidth="1.5" />
          <text x="245" y={r.y + 3} fill={M} fontSize="8" fontFamily="monospace">{r.d}</text>
        </g>
      ))}
      <path d="M30 155 Q120 20 230 40" stroke={Y} strokeWidth="1.5" fill="none" strokeDasharray="5 4" />
    </Frame>
  );
}

function ChippingZone() {
  return (
    <Frame label="chipping landing zone drill">
      <circle cx="30" cy="150" r="7" fill={W} />
      <text x="12" y="140" fill={M} fontSize="8" fontFamily="monospace">BALL</text>
      <path d="M30 148 Q120 20 175 70" stroke={Y} strokeWidth="2" fill="none" />
      <rect x="150" y="60" width="50" height="24" fill="none" stroke={Y} strokeWidth="1.5" strokeDasharray="4 3" />
      <text x="150" y="55" fill={Y} fontSize="8" fontFamily="monospace">LANDING</text>
      <path d="M175 84 Q220 120 275 150" stroke={M} strokeWidth="1.5" fill="none" strokeDasharray="3 3" />
      <text x="200" y="120" fill={M} fontSize="8" fontFamily="monospace">ROLLOUT</text>
      <circle cx="278" cy="152" r="9" fill="none" stroke={R} strokeWidth="2" />
      <text x="255" y="172" fill={M} fontSize="8" fontFamily="monospace">HOLE</text>
    </Frame>
  );
}

function DriverCorridor() {
  return (
    <Frame label="driver corridor drill">
      <circle cx="160" cy="160" r="6" fill={W} />
      <text x="170" y="164" fill={M} fontSize="8" fontFamily="monospace">TEE</text>
      <line x1="110" y1="20" x2="150" y2="160" stroke={Y} strokeWidth="1.5" strokeDasharray="4 4" />
      <line x1="210" y1="20" x2="170" y2="160" stroke={Y} strokeWidth="1.5" strokeDasharray="4 4" />
      <rect x="110" y="20" width="100" height="140" fill={Y} opacity="0.06" />
      <text x="130" y="16" fill={Y} fontSize="8" fontFamily="monospace">FAIRWAY CORRIDOR</text>
      <line x1="160" y1="155" x2="160" y2="25" stroke={M} strokeWidth="1" strokeDasharray="2 4" />
      <polygon points="160,18 156,28 164,28" fill={W} />
    </Frame>
  );
}

function ApproachTarget() {
  return (
    <Frame label="approach target drill">
      <circle cx="30" cy="150" r="7" fill={W} />
      <text x="12" y="140" fill={M} fontSize="8" fontFamily="monospace">BALL</text>
      <path d="M30 148 Q150 -10 250 70" stroke={Y} strokeWidth="2" fill="none" />
      <circle cx="250" cy="80" r="34" fill="none" stroke="#333" strokeWidth="1" />
      <circle cx="250" cy="80" r="20" fill="none" stroke={M} strokeWidth="1" />
      <circle cx="250" cy="80" r="8" fill="none" stroke={Y} strokeWidth="1.5" />
      <circle cx="250" cy="80" r="2" fill={R} />
      <text x="215" y="130" fill={M} fontSize="8" fontFamily="monospace">TARGET ZONE</text>
    </Frame>
  );
}

function AlignmentStation() {
  return (
    <Frame label="alignment station drill">
      <line x1="40" y1="120" x2="280" y2="70" stroke={Y} strokeWidth="3" />
      <line x1="40" y1="140" x2="280" y2="90" stroke={M} strokeWidth="2" strokeDasharray="5 4" />
      <circle cx="90" cy="128" r="6" fill={W} />
      <circle cx="120" cy="126" r="6" fill={W} />
      <circle cx="150" cy="124" r="6" fill={W} />
      <text x="40" y="60" fill={Y} fontSize="8" fontFamily="monospace">TARGET LINE</text>
      <line x1="230" y1="76" x2="230" y2="40" stroke={M} strokeWidth="1" strokeDasharray="2 3" />
      <polygon points="230,34 226,44 234,44" fill={W} />
    </Frame>
  );
}

function BodyFigure({ label }) {
  return (
    <Frame label={label}>
      <circle cx="160" cy="45" r="14" fill="none" stroke={Y} strokeWidth="2.5" />
      <line x1="160" y1="59" x2="160" y2="110" stroke={Y} strokeWidth="2.5" />
      <line x1="160" y1="72" x2="128" y2="95" stroke={Y} strokeWidth="2.5" />
      <line x1="160" y1="72" x2="192" y2="95" stroke={Y} strokeWidth="2.5" />
      <line x1="160" y1="110" x2="138" y2="150" stroke={Y} strokeWidth="2.5" />
      <line x1="160" y1="110" x2="182" y2="150" stroke={Y} strokeWidth="2.5" />
      <path d="M120 40 A44 44 0 0 1 200 40" stroke={M} strokeWidth="1.5" fill="none" strokeDasharray="4 4" />
      <polygon points="200,40 196,31 205,33" fill={M} />
      <text x="118" y="172" fill={M} fontSize="8" fontFamily="monospace">CONTROLLED · FULL RANGE</text>
    </Frame>
  );
}

const MAP = {
  putting_gate: PuttingGate,
  lag_ladder: LagLadder,
  chipping_zone: ChippingZone,
  driver_corridor: DriverCorridor,
  approach_target: ApproachTarget,
  alignment_station: AlignmentStation,
  mobility: (p) => <BodyFigure label="mobility movement" {...p} />,
  strength: (p) => <BodyFigure label="strength movement" {...p} />,
  generic: (p) => <BodyFigure label="drill" {...p} />,
};

export default function DrillDiagram({ type }) {
  const Comp = MAP[type] || MAP.generic;
  return <Comp />;
}
